export default __webpack_public_path__ + "static/media/avatar_arrow_boy5.f7bbfee7.mp3";